import { render } from "./ViewBeneficiaryCommitmentModal.vue?vue&type=template&id=65c91024&scoped=true"
import script from "./ViewBeneficiaryCommitmentModal.vue?vue&type=script&lang=js"
export * from "./ViewBeneficiaryCommitmentModal.vue?vue&type=script&lang=js"

import "./ViewBeneficiaryCommitmentModal.vue?vue&type=style&index=0&id=65c91024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c91024"]])

export default __exports__